<app-basic-card class="w-100">
    <h5>Operazioni del mese</h5>
    <div class="d-flex justify-content-around">
        <ng-container *ngFor="let item of kpis">
            <div class="d-flex flex-column align-items-center">
                <img class="kpi-company-logo" [src]="getCompanyLogo(item?.companyId)" alt="company-logo">
                <div class="d-flex flex-column text-center pt-4">
                    <ng-container *ngFor="let kpi of item?.kpis">
                        <div class="pb-4">
                            <h3 class="m-0">{{ countersType === 'premium' ?  (kpi?.key | currency: 'EUR') : kpi?.key }}</h3>
                            <p class="m-0">{{kpi?.label | uppercase}}</p>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</app-basic-card>